import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function HGSSIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="HGSSIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">

      <circle fill="#FFFFFF" cx="50" cy="50" r="38.801" />
      <path fill="#FF0000" d="M56.4,57.6c-0.8-0.6-1.4-1.3-1.8-2.1c0.4,1,1.6,3.9,1.1,4.9c-0.1,0.2-0.3,0.4-0.5,0.4h-0.1
	c-0.8,0-1.6-1.1-2.4-2.2c-0.2-0.2-0.3-0.5-0.5-0.7c0.1,1,0,2.1-0.4,3.4c-0.4,1.2-0.3,2.4-0.2,3.5s0.2,1.9-0.3,2.4
	c-0.2,0.2-0.5,0.3-0.8,0.3h-0.1c-1.5-0.1-2.6-4.8-2.7-5.7c-0.2-1.5-0.4-3-0.1-4.2c-0.5,0.5-1.2,0.9-2,1.4c-1.1,0.6-2.3,1.3-3.5,2.5
	l0,0v11c2.5,0.9,5.2,1.4,8,1.4s5.5-0.5,8-1.4V59.3C57.6,58.7,57.1,58.1,56.4,57.6z"/>
      <path fill="#FF0000" d="M43,56.7c0.4-0.5,0.9-1.2,1.7-1.9c-0.2,0.2-0.5,0.3-0.8,0.5C43,55.8,42,55.9,41,56.1h-0.3
	c-1,0.2-1.8,0.4-2.7,0.8c-0.3,0.2-0.8,0.4-1.2,0.4c-0.3,0-0.5-0.1-0.7-0.4c-0.5-0.8,0.8-2.2,1.2-2.5c0.9-0.8,1.8-1,2.7-1.2
	c0.7-0.2,1.5-0.3,2.3-0.7c0.2-0.1,0.4-0.2,0.6-0.3c-0.2,0-0.4,0-0.6,0c-0.4,0-0.6,0-0.9-0.1c-0.4,0-0.8-0.1-1.5,0
	c-1.1,0.2-1.8-0.3-1.9-0.9c-0.1-0.5,0.1-1.1,1-1.5c0.5-0.2,1-0.3,1.5-0.4c-0.1-0.1-0.2-0.1-0.4-0.2c-2.5-1.4-3.9-1.4-5-1.4
	c-0.7,0-1.3,0-1.8-0.5s-0.4-1-0.3-1.2c0.4-0.9,2.3-1.2,5-0.8c1.9,0.2,3.4,0.5,4.5,0.9c-0.5-0.4-1.1-1-1.8-1.6
	c-0.6-0.7-1.1-1.4-1.6-2.2c-0.1-0.1-0.2-0.2-0.2-0.4H27.5c-0.9,2.5-1.4,5.2-1.4,8s0.5,5.5,1.4,8h14.3C42.3,57.6,42.6,57.1,43,56.7z"
      />
      <path fill="#FF0000" d="M43.6,42c0.9,0.3,1.5,0.8,2,1.4c0-0.1,0-0.2-0.1-0.3c-0.1-0.4-0.1-0.8-0.5-1.2c-0.4-0.5-0.3-1.1,0.1-1.5
	c0.4-0.3,1.1-0.4,1.8,0.3c0.4,0.5,0.7,1,1,1.5c-0.1-1.5,0.1-2.9,0.4-4.3c0.2-1.3,0.4-2.5,0.3-3.7c0-0.3,0-0.8,0-1
	c0.2-0.5,0.7-0.8,1.3-0.7c0.4,0.1,0.7,0.4,1,0.8c0.3,0.4,0.5,0.9,0.7,1.4v0.1c0.9,2.4,0.8,4.2,0.6,5.7c-0.1,0.6-0.1,1.2-0.1,1.8
	c0.4-0.7,1.3-1.6,3.1-2.5c0.6-0.3,1.6-0.6,2.6-0.8V27.6c-2.5-0.9-5.2-1.4-8-1.4s-5.5,0.5-8,1.4v13.8C42.5,41.6,43.2,41.8,43.6,42
	L43.6,42z"/>
      <path fill="#FF0000" d="M72.4,42H58.7c-0.8,0.5-1.1,1.1-1.3,1.6c-0.3,0.6-0.6,1.2-1.5,1.7c0,0,0,0,0.1,0c1.7-0.1,2.2-0.7,2.6-1.2
	c0.3-0.3,0.6-0.7,1-0.6c0.3,0.1,0.6,0.3,0.7,0.6c0.2,0.7-0.2,2.2-1.5,3.4c-0.5,0.5-1.1,0.9-1.6,1.1c0.2-0.1,0.5-0.1,0.7-0.1l0,0
	c1.4,0,5.8,0.7,8.1,2.4c1,0.7,1.3,1.5,1.1,2.1c-0.2,0.6-0.9,0.8-1.5,0.8c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.2-1.4-0.4
	c-0.1,0-0.2-0.1-0.3-0.1c-1.2-0.4-2.4-0.6-3.6-0.6c-0.3,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.3,0.3-2,0.1l0,0c0.3,0.1,0.7,0.3,1.1,0.6
	c1.3,0.8,2.2,2.1,2.9,4.3V58h11.5c0.9-2.5,1.4-5.2,1.4-8C73.8,47.2,73.3,44.5,72.4,42z"/>
      <path fill="#005094" d="M50,15c-19.3,0-35,15.7-35,35s15.7,35,35,35s35-15.7,35-35S69.3,15,50,15z M50,75.301
	c-13.973,0-25.301-11.327-25.301-25.301c0-13.973,11.328-25.301,25.301-25.301S75.301,36.027,75.301,50S63.973,75.301,50,75.301z"/>
      <circle fill="#FF0000" cx="52.8" cy="46.997" r="1.551" />
      <circle fill="#FF0000" cx="53.8" cy="51.697" r="1.551" />
      <circle fill="#FF0000" cx="49.6" cy="54.097" r="1.551" />
      <circle fill="#FF0000" cx="46" cy="50.8" r="1.551" />
      <circle fill="#FF0000" cx="48" cy="46.4" r="1.551" />
      <circle fill="#FF0000" cx="50" cy="50" r="1.8" />
    </svg>
  </SvgIcon>
}

export default HGSSIcon;
